export const AuthAction = {
    LOGIN: 'LOGIN',
    LOGOUT: 'LOGOUT',
    LOAD_USER: 'LOAD_USER',
    UPDATE_USER: 'UPDATE_USER',
    UPDATE_USER_WITH_LOGO: 'UPDATE_USER_WITH_LOGO',
};

export const AuthMutation = {
    AUTH_REQUEST: 'AUTH_REQUEST',
    AUTH_SUCCESS: 'AUTH_SUCCESS',
    AUTH_ERROR: 'AUTH_ERROR',
    AUTH_LOGOUT: 'AUTH_LOGOUT',
    UPDATE_SUCCESS: 'UPDATE_SUCCESS',
    UPDATE_ERROR: 'UPDATE_ERROR',
};